import { useState } from "react";
import { Menu, Check, X } from "lucide-react";
import { useForm, STEP_TITLES } from "../../context/FormContext";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "../ui/sheet";

export default function MobileNavDrawer() {
  const { step, setStep } = useForm();
  const [open, setOpen] = useState(false);

  const handleClick = (idx) => {
    if (idx < step) {
      setStep(idx);
      setOpen(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          type="button"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-slate-100 transition-colors shrink-0"
          aria-label="Apri navigazione step"
          data-testid="mobile-nav-trigger"
        >
          <Menu size={22} className="text-slate-700" />
        </button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="w-[88%] max-w-sm bg-slate-900 text-white border-0 p-0 overflow-y-auto"
        data-testid="mobile-nav-drawer"
      >
        <div className="p-6 flex flex-col h-full">
          <div className="flex items-start justify-between mb-6">
            <img
              src="/logo-unioncasa-white.png"
              alt="UnionCasa"
              className="w-44 select-none"
            />
            <SheetClose asChild>
              <button
                type="button"
                className="text-slate-400 hover:text-white p-1 -mr-1"
                aria-label="Chiudi"
                data-testid="mobile-nav-close"
              >
                <X size={20} />
              </button>
            </SheetClose>
          </div>

          <p className="text-sm font-light text-slate-300 tracking-wide">
            Attestazione per Canone Concordato
          </p>
          <h2 className="font-serif text-5xl font-light leading-none tracking-tight text-white mt-1 mb-6">
            Milano
          </h2>

          <nav className="space-y-1 flex-1" data-testid="mobile-step-nav">
            {STEP_TITLES.map((title, i) => {
              const idx = i + 1;
              const isActive = idx === step;
              const isDone = idx < step;
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => handleClick(idx)}
                  disabled={idx > step}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded text-left transition-colors ${
                    isActive
                      ? "bg-white/10 text-white"
                      : isDone
                      ? "text-slate-300 hover:bg-white/5 cursor-pointer"
                      : "text-slate-500"
                  }`}
                  data-testid={`mobile-step-nav-${idx}`}
                >
                  <span
                    className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-medium shrink-0 ${
                      isDone
                        ? "bg-green-800 text-white"
                        : isActive
                        ? "bg-white text-slate-900"
                        : "bg-white/10 text-slate-400"
                    }`}
                  >
                    {isDone ? <Check size={14} /> : idx}
                  </span>
                  <span className={`text-sm ${isActive ? "font-medium" : ""}`}>
                    {title}
                  </span>
                </button>
              );
            })}
          </nav>

          <p className="text-[11px] text-slate-500 mt-6 leading-relaxed">
            Accordo locale per la città di Milano. Depositato il 12/06/2023.
          </p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
